import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ReactSelect from "react-select";
import {
  EmployeePerformanceReportUpdate,
  EmployeeProfile,
  StaffSpecificPerformanceSavedReport,
} from "../../Repository/Api";
import { Restrict } from "../Common/FinancialYear";
import CustomModal from "../CustomModal";
import { errorMsg, successMsg } from "../Toastify";
const StaffPerformanceSpecific = () => {
  const { access_token, department, desingation, first_name } = useSelector((state) => state?.auth?.auth);
  const token = access_token;
  const navigate = useNavigate();
  const { id } = useParams();

  const [count, setCount] = useState({});

  const [statusAcceptModel, setStatusAcceptModel] = useState(false);
  const [validation, setValidation] = useState({});

  useEffect(() => {
    getCount();
  }, []);

  const [active, setActive] = useState(0);
  const links = ["Part - A", "Part - B", "Part - C", "Part - D"];
  const showSelected = (index) => {
    setActive(index);
  };

  const [apply, setApply] = useState({
    academic_contributions: {
      non_sponsored_training: 0,
      training_programmes_conducted: 0,
      sponsored_contact_mode_for_coordinator_training: 0,
      sponsored_contact_mode_for_co_coordinator_training: 0,
      skill_development_for_coordinator_training: 0,
      skill_development_for_co_coordinator_training: 0,
      development_of_moocs_offering_swayam_courses_or_nittt_module: 0,
      development_for_minimum_30_min_video: 0,
      resouce_program_in_training_programmes: 0,
      development_of_training_manual: 0,
      coursed_handled_for_pg_phd_programme: 0,
      new_courses_developed_and_offered: 0,
      curriculum_developed_revised_lt_3_lakhs: 0,
      curriculum_developed_revised_3_to_5_lakhs: 0,
      curriculum_developed_revised_5_to_10_lakhs: 0,
      curriculum_developed_revised_10_to_15_lakhs: 0,
      curriculum_developed_revised_gt_15_lakhs: 0,
      aid_training_programmes_lt_3_lakhs: 0,
      aid_training_programmes_3_t0_5_lakhs: 0,
      aid_training_programmes_gt_5_lakhs: 0,
    },
    research_contributions: {
      phd_research_guidance: 0,
      post_graduate_thesis_guidance: 0,
      sponsored_research_projects_submitted: 0,
      sponsored_research_projects_lt_5_lakhs: 0,
      sponsored_research_projects_5_to_15_lakhs: 0,
      sponsored_research_projects_gt_15_lakhs: 0,
      consultancy_works_carried_out_lt_3_lakhs: 0,
      consultancy_works_carried_out_3_to_5_lakhs: 0,
      consultancy_works_carried_out_gt_5_lakhs: 0,
      research_publications_in_sci: 0,
      research_publications_in_scopus_indexed: 0,
      research_publications_in_ugc_listed: 0,
      paper_presented_in_international: 0,
      paper_presented_in_national: 0,
      books_international_publisher: 0,
      books_national_publisher: 0,
      book_chapter_international_publisher: 0,
      book_chapter_national_publisher: 0,
      patents_granted: 0,
      patents_filed_international: 0,
      patents_granted_international: 0,
      patents_filed: 0,
      international_awards: 0,
      national_awards: 0,
    },
    institutional_development: {
      administrative_contributions_hod_of_the_committee: 0,
      administrative_contributions_member_of_the_committee: 0,
      infrastructure_development_internal_funding_upto_10_lakhs: 0,
      infrastructure_development_external_funding_upto_5_lakhs: 0,
      // revenue_generated_through_training_programmes_lt_3_lakhs: 0,
      // revenue_generated_through_training_programmes_3_to_5_lakhs: 0,
      // revenue_generated_through_training_programmes_gt_5_lakhs: 0,
      research_or_academic_events_international: 0,
      research_or_academic_events_national: 0,
      events_conducted_with_revenue_generation: 0,
      events_conducted_without_revenue_generation: 0,
      new_initiatives_implemented_with_revenue_generation: 0,
      new_initiatives_implemented_without_revenue_generation: 0,
    },
    professional_contributions: {
      resource_person_in_training_programmes: 0,
      training_programmes_attended_international: 0,
      training_programmes_attended_national: 0,
      participation_and_academic_contributions_international: 0,
      participation_and_academic_contributions_national: 0,
      participation_and_academic_contributions_state: 0,
      overseas_visited_for_academic_events: 0,
      overseas_visited_for_part_of_delegation: 0,
      participation_and_contributions_in_pg_examiner: 0,
      participation_and_contributions_in_doctoral_committee: 0,
      participation_and_contributions_in_phd_examiner: 0,
      editor_in_cheif_sci: 0,
      editor_in_cheif_scopus: 0,
      editorial_board_member_sci: 0,
      editorial_board_member_scopus: 0,
      peer_reviewer_sci: 0,
      peer_reviewer_scopus: 0,
      international_academic_assignment: 0,
      national_academic_assignment: 0,
      fellow: 0,
      life_member: 0,
      member: 0,
    },
  });

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const getMonthName = (monthNumber) => {
    return new Intl.DateTimeFormat("en-US", { month: "long" }).format(
      new Date(2022, monthNumber - 1, 1)
    );
  };
  const d = new Date();

  const monthLength = d.getMonth() + 1;
  const month = Array.from({ length: monthLength }, (_, index) => {
    const previousMonthValue = (currentMonth - index + 12) % 12 || 12;
    return {
      value: previousMonthValue,
      label: `${getMonthName(previousMonthValue)}`,
    };
  });

  const setData = (e, key, subKey) => {
    setApply((prevState) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        [subKey]: e,
      },
    }));
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };
  const setNormalData = (e, key) => {
    setApply({ ...apply, [key]: e });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const getCount = async () => {
    const response = await StaffSpecificPerformanceSavedReport(id, token);
    if (response && response.statusCode === 200) {
      setCount(response?.data);
      const partA = response?.data;
      const partB = response?.data?.research_contributions;
      const partC = response?.data?.institutional_development;
      const partD = response?.data?.professional_contributions;
      setApply({
        academic_contributions: {
          non_sponsored_training:
            partA?.academic_contributions?.non_sponsored_training
              ?.total_activity,
          training_programmes_conducted:
            partA?.academic_contributions?.training_programmes_conducted
              ?.total_activity,
          sponsored_contact_mode_for_coordinator_training:
            partA?.academic_contributions
              ?.sponsored_contact_mode_for_coordinator_training?.total_activity,
          sponsored_contact_mode_for_co_coordinator_training:
            partA?.academic_contributions
              ?.sponsored_contact_mode_for_co_coordinator_training
              ?.total_activity,
          skill_development_for_coordinator_training:
            partA?.academic_contributions
              ?.skill_development_for_coordinator_training?.total_activity,
          skill_development_for_co_coordinator_training:
            partA?.academic_contributions
              ?.skill_development_for_co_coordinator_training?.total_activity,
          development_of_moocs_offering_swayam_courses_or_nittt_module:
            partA?.academic_contributions
              ?.development_of_moocs_offering_swayam_courses_or_nittt_module
              ?.total_activity,
          development_for_minimum_30_min_video:
            partA?.academic_contributions?.development_for_minimum_30_min_video
              ?.total_activity,
          resouce_program_in_training_programmes:
            partA?.academic_contributions
              ?.resouce_program_in_training_programmes?.total_activity,
          development_of_training_manual:
            partA?.academic_contributions?.development_of_training_manual
              ?.total_activity,
          coursed_handled_for_pg_phd_programme:
            partA?.academic_contributions?.coursed_handled_for_pg_phd_programme
              ?.total_activity,
          new_courses_developed_and_offered:
            partA?.academic_contributions?.new_courses_developed_and_offered
              ?.total_activity,
          curriculum_developed_revised_lt_3_lakhs:
            partA?.academic_contributions
              ?.curriculum_developed_revised_lt_3_lakhs?.total_activity,
          curriculum_developed_revised_3_to_5_lakhs:
            partA?.academic_contributions
              ?.curriculum_developed_revised_3_to_5_lakhs?.total_activity,
          curriculum_developed_revised_5_to_10_lakhs:
            partA?.academic_contributions
              ?.curriculum_developed_revised_5_to_10_lakhs?.total_activity,
          curriculum_developed_revised_10_to_15_lakhs:
            partA?.academic_contributions
              ?.curriculum_developed_revised_10_to_15_lakhs?.total_activity,
          curriculum_developed_revised_gt_15_lakhs:
            partA?.academic_contributions
              ?.curriculum_developed_revised_gt_15_lakhs?.total_activity,
          aid_training_programmes_lt_3_lakhs:
            partA?.academic_contributions?.aid_training_programmes_lt_3_lakhs
              ?.total_activity,
          aid_training_programmes_3_t0_5_lakhs:
            partA?.academic_contributions?.aid_training_programmes_3_t0_5_lakhs
              ?.total_activity,
          aid_training_programmes_gt_5_lakhs:
            partA?.academic_contributions?.aid_training_programmes_gt_5_lakhs
              ?.total_activity,
        },
        research_contributions: {
          phd_research_guidance: partB?.phd_research_guidance?.total_activity,
          post_graduate_thesis_guidance:
            partB?.post_graduate_thesis_guidance?.total_activity,
          sponsored_research_projects_submitted:
            partB?.sponsored_research_projects_submitted?.total_activity,
          sponsored_research_projects_lt_5_lakhs:
            partB?.sponsored_research_projects_lt_5_lakhs?.total_activity,
          sponsored_research_projects_5_to_15_lakhs:
            partB?.sponsored_research_projects_5_to_15_lakhs?.total_activity,
          sponsored_research_projects_gt_15_lakhs:
            partB?.sponsored_research_projects_gt_15_lakhs?.total_activity,
          consultancy_works_carried_out_lt_3_lakhs:
            partB?.consultancy_works_carried_out_lt_3_lakhs?.total_activity,
          consultancy_works_carried_out_3_to_5_lakhs:
            partB?.consultancy_works_carried_out_3_to_5_lakhs?.total_activity,
          consultancy_works_carried_out_gt_5_lakhs:
            partB?.consultancy_works_carried_out_gt_5_lakhs?.total_activity,
          research_publications_in_sci:
            partB?.research_publications_in_sci?.total_activity,
          research_publications_in_scopus_indexed:
            partB?.research_publications_in_scopus_indexed?.total_activity,
          research_publications_in_ugc_listed:
            partB?.research_publications_in_ugc_listed?.total_activity,
          paper_presented_in_international:
            partB?.paper_presented_in_international?.total_activity,
          paper_presented_in_national:
            partB?.paper_presented_in_national?.total_activity,
          books_international_publisher:
            partB?.books_international_publisher?.total_activity,
          books_national_publisher:
            partB?.books_national_publisher?.total_activity,
          book_chapter_international_publisher:
            partB?.book_chapter_international_publisher?.total_activity,
          book_chapter_national_publisher:
            partB?.book_chapter_national_publisher?.total_activity,
          patents_granted: partB?.patents_granted?.total_activity,
          patents_filed_international:
            partB?.patents_filed_international?.total_activity,
          patents_granted_international:
            partB?.patents_granted_international?.total_activity,
          patents_filed: partB?.patents_filed?.total_activity,
          international_awards: partB?.international_awards?.total_activity,
          national_awards: partB?.national_awards?.total_activity,
        },
        institutional_development: {
          administrative_contributions_hod_of_the_committee:
            partC?.administrative_contributions_hod_of_the_committee
              ?.total_activity,
          administrative_contributions_member_of_the_committee:
            partC?.administrative_contributions_member_of_the_committee
              ?.total_activity,
          infrastructure_development_internal_funding_upto_10_lakhs:
            partC?.infrastructure_development_internal_funding_upto_10_lakhs
              ?.total_activity,
          infrastructure_development_external_funding_upto_5_lakhs:
            partC?.infrastructure_development_external_funding_upto_5_lakhs
              ?.total_activity,
          // revenue_generated_through_training_programmes_lt_3_lakhs: 0,
          // revenue_generated_through_training_programmes_3_to_5_lakhs: 0,
          // revenue_generated_through_training_programmes_gt_5_lakhs: 0,
          research_or_academic_events_international:
            partC?.research_or_academic_events_international?.total_activity,
          research_or_academic_events_national:
            partC?.research_or_academic_events_national?.total_activity,
          events_conducted_with_revenue_generation:
            partC?.events_conducted_with_revenue_generation?.total_activity,
          events_conducted_without_revenue_generation:
            partC?.events_conducted_without_revenue_generation?.total_activity,
          new_initiatives_implemented_with_revenue_generation:
            partC?.new_initiatives_implemented_with_revenue_generation
              ?.total_activity,
          new_initiatives_implemented_without_revenue_generation:
            partC?.new_initiatives_implemented_without_revenue_generation
              ?.total_activity,
        },
        professional_contributions: {
          resource_person_in_training_programmes:
            partD?.resource_person_in_training_programmes?.total_activity,
          training_programmes_attended_international:
            partD?.training_programmes_attended_international?.total_activity,
          training_programmes_attended_national:
            partD?.training_programmes_attended_national?.total_activity,
          participation_and_academic_contributions_international:
            partD?.participation_and_academic_contributions_international
              ?.total_activity,
          participation_and_academic_contributions_national:
            partD?.participation_and_academic_contributions_national
              ?.total_activity,
          participation_and_academic_contributions_state:
            partD?.participation_and_academic_contributions_state
              ?.total_activity,
          overseas_visited_for_academic_events:
            partD?.overseas_visited_for_academic_events?.total_activity,
          overseas_visited_for_part_of_delegation:
            partD?.overseas_visited_for_part_of_delegation?.total_activity,
          participation_and_contributions_in_pg_examiner:
            partD?.participation_and_contributions_in_pg_examiner
              ?.total_activity,
          participation_and_contributions_in_doctoral_committee:
            partD?.participation_and_contributions_in_doctoral_committee
              ?.total_activity,
          participation_and_contributions_in_phd_examiner:
            partD?.participation_and_contributions_in_phd_examiner
              ?.total_activity,
          editor_in_cheif_sci: partD?.editor_in_cheif_sci?.total_activity,
          editor_in_cheif_scopus: partD?.editor_in_cheif_scopus?.total_activity,
          editorial_board_member_sci:
            partD?.editorial_board_member_sci?.total_activity,
          editorial_board_member_scopus:
            partD?.editorial_board_member_scopus?.total_activity,
          peer_reviewer_sci: partD?.peer_reviewer_sci?.total_activity,
          peer_reviewer_scopus: partD?.peer_reviewer_scopus?.total_activity,
          international_academic_assignment:
            partD?.international_academic_assignment?.total_activity,
          national_academic_assignment:
            partD?.national_academic_assignment?.total_activity,
          fellow: partD?.fellow?.total_activity,
          life_member: partD?.life_member?.total_activity,
          member: partD?.member?.total_activity,
        },
      });
    } else {
      errorMsg(response.message);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const Payload = {
      ...apply,
      id: id,
    };
    const response = await EmployeePerformanceReportUpdate(Payload, token);
    if (response && response.statusCode === 200) {
      successMsg(response.message);
      setStatusAcceptModel(false);
      navigate(-1);
    } else {
      errorMsg(response.message);
    }
  };


  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">
                  {first_name} - {desingation}
                </h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <form>
                  <div className="row">
                    <div className="col-lg-5 my-auto">
                      <h6 className="labeltitle">
                        <span
                          className="arrowicon"
                          onClick={() => {
                            navigate(-1);
                          }}
                        >
                          ← &nbsp;
                        </span>
                        Performance Report Status
                      </h6>
                    </div>
                    <div className="col-lg-4 my-auto">
                      <div>
                        <label className="labeltext">Selected Year</label>
                        <input
                          className="fieldinput"
                          value={count?.academic_year}
                          disabled
                        />
                      </div>
                      <small className="validationerror">
                        {validation?.academic_year?.message
                          ? `Year ${validation?.academic_year?.message}`
                          : ""}
                      </small>
                    </div>
                    {apply.academic_year === currentYear ? (
                      <div className="col-lg-4 my-auto">
                        <div>
                          <label className="labeltext">Select Month</label>
                          <ReactSelect
                            isMulti={false}
                            value={apply?.month}
                            onChange={(e) => {
                              setNormalData(e, "month");
                            }}
                            options={month}
                          />
                        </div>
                        <small className="validationerror">
                          {validation?.month?.message
                            ? `Month ${validation?.month?.message}`
                            : ""}
                        </small>
                      </div>
                    ) : (
                      <div className="col-lg-4 my-auto displaynone">
                        <input
                          type="number"
                          min={0}
                          max={100}
                          onKeyDown={(e) => Restrict(e)}
                          placeholder="Enter count"
                          className="fieldinput"
                          value={apply?.months}
                          onChange={(e) => {
                            setNormalData(e, "months");
                          }}
                        />
                      </div>
                    )}
                  </div>
                  <div className="mt-5">
                    <ul className="searchtopflex">
                      {links.map((link, index) => {
                        return (
                          <li
                            onClick={() => showSelected(index)}
                            key={link}
                            className={
                              active === index
                                ? "agenttextactive"
                                : "agenttextinactive"
                            }
                          >
                            {link}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                  {active === 0 && (
                    <>
                      <h5 className="centertext my-5">
                        ACADEMIC CONTRIBUTIONS
                      </h5>
                      <table className="tablereport table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">Topic</th>
                            <th scope="col">Criteria</th>
                            <th scope="col">Target Fixed</th>
                            <th scope="col">Score/Item</th>
                            <th scope="col">Score Fixed</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="tablewidth">
                              a. Grant in aid Training Programmes conducted
                              as Coordinator Training programmes conducted for 3
                              days as 0.5 equivalence and "n" weeks as "n"
                              equivalence of 5 days Conduct of number of 5 days
                              training programmes 20, 18 and 16 for Assistant
                              Professor, Associate Professor and Professor
                              respectively. Revenue Generated through Training Programmes as Co-ordinator
                            </td>
                            <td>
                              <tr>
                                <td>
                                  Training Programmes conducted as Coordinator
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  Additional training programmes conducted as
                                  Coordinator
                                </td>
                              </tr>
                              <br />

                              <tr>
                                <td>&lt; 3 lakhs</td>
                              </tr>
                              <br />

                              <tr>
                                <td>3-5 lakhs</td>
                              </tr>
                              <br />

                              <tr>
                                <td>&gt; 5 lakhs</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter count"
                                    className="fieldinput"
                                    value={
                                      apply?.academic_contributions
                                        ?.non_sponsored_training
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "academic_contributions",
                                        "non_sponsored_training"
                                      )
                                    }
                                    onWheelCapture={e => {
                                      e.target.blur()
                                    }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter count"
                                    className="fieldinput"
                                    value={
                                      apply?.academic_contributions
                                        ?.training_programmes_conducted
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "academic_contributions",
                                        "training_programmes_conducted"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter count"
                                    className="fieldinput"
                                    value={
                                      apply?.academic_contributions
                                        ?.aid_training_programmes_lt_3_lakhs
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "academic_contributions",
                                        "aid_training_programmes_lt_3_lakhs"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter count"
                                    className="fieldinput"
                                    value={
                                      apply?.academic_contributions
                                        ?.aid_training_programmes_3_t0_5_lakhs
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "academic_contributions",
                                        "aid_training_programmes_3_t0_5_lakhs"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter count"
                                    className="fieldinput"
                                    value={
                                      apply?.academic_contributions
                                        ?.aid_training_programmes_gt_5_lakhs
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "academic_contributions",
                                        "aid_training_programmes_gt_5_lakhs"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.academic_contributions
                                      ?.non_sponsored_training
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.academic_contributions
                                      ?.training_programmes_conducted
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.academic_contributions
                                      ?.aid_training_programmes_lt_3_lakhs
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.academic_contributions
                                      ?.aid_training_programmes_3_t0_5_lakhs
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.academic_contributions
                                      ?.aid_training_programmes_gt_5_lakhs
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.academic_contributions
                                    ?.non_sponsored_training *
                                    count?.academic_contributions
                                      ?.non_sponsored_training
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.academic_contributions
                                    ?.training_programmes_conducted *
                                    count?.academic_contributions
                                      ?.training_programmes_conducted
                                      ?.per_actitity_score}{" "}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.academic_contributions
                                    ?.aid_training_programmes_lt_3_lakhs *
                                    count?.academic_contributions
                                      ?.aid_training_programmes_lt_3_lakhs
                                      ?.per_actitity_score}{" "}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.academic_contributions
                                    ?.aid_training_programmes_3_t0_5_lakhs *
                                    count?.academic_contributions
                                      ?.aid_training_programmes_3_t0_5_lakhs
                                      ?.per_actitity_score}{" "}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.academic_contributions
                                    ?.aid_training_programmes_gt_5_lakhs *
                                    count?.academic_contributions
                                      ?.aid_training_programmes_gt_5_lakhs
                                      ?.per_actitity_score}{" "}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              b. Sponsored Training Programmes
                              conducted as Coordinator/ Co-coordinator (Funded by State/ Central Government or ITEC)
                            </td>
                            <td>
                              <tr>
                                <td>
                                  Training programmes conducted as Coordinator
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  Training programmes conducted as
                                  Co-coordinator
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.academic_contributions
                                        ?.sponsored_contact_mode_for_coordinator_training ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "academic_contributions",
                                        "sponsored_contact_mode_for_coordinator_training"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.academic_contributions
                                        ?.sponsored_contact_mode_for_co_coordinator_training ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "academic_contributions",
                                        "sponsored_contact_mode_for_co_coordinator_training"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.academic_contributions
                                      ?.sponsored_contact_mode_for_coordinator_training
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.academic_contributions
                                      ?.sponsored_contact_mode_for_co_coordinator_training
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.academic_contributions
                                    ?.sponsored_contact_mode_for_coordinator_training *
                                    count?.academic_contributions
                                      ?.sponsored_contact_mode_for_coordinator_training
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.academic_contributions
                                    ?.sponsored_contact_mode_for_co_coordinator_training *
                                    count?.academic_contributions
                                      ?.sponsored_contact_mode_for_co_coordinator_training
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              c. Skill Development/ Industrial Training
                              Programmes conducted as Coordinator/
                              Co-coordinator
                            </td>
                            <td>
                              <tr>
                                <td>
                                  Training programmes conducted as Coordinator
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  Training programmes conducted as
                                  Co-coordinator
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.academic_contributions
                                        ?.skill_development_for_coordinator_training ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "academic_contributions",
                                        "skill_development_for_coordinator_training"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.academic_contributions
                                        ?.skill_development_for_co_coordinator_training ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "academic_contributions",
                                        "skill_development_for_co_coordinator_training"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.academic_contributions
                                      ?.skill_development_for_coordinator_training
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.academic_contributions
                                      ?.skill_development_for_co_coordinator_training
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.academic_contributions
                                    ?.skill_development_for_coordinator_training *
                                    count?.academic_contributions
                                      ?.skill_development_for_coordinator_training
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.academic_contributions
                                    ?.skill_development_for_co_coordinator_training *
                                    count?.academic_contributions
                                      ?.skill_development_for_co_coordinator_training
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              d. Development/ offer of MOOCs/ MMLPs as Coordinator/
                              Co-coordinator or minimum 30 min video lectures/
                              Educational video films
                            </td>
                            <td>
                              <tr>
                                <td>Offering of SWAYAM Course/ NITTT module</td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  Development of minimum 30 min video lecture/
                                  Educational video films
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.academic_contributions
                                        ?.development_of_moocs_offering_swayam_courses_or_nittt_module ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "academic_contributions",
                                        "development_of_moocs_offering_swayam_courses_or_nittt_module"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.academic_contributions
                                        ?.development_for_minimum_30_min_video ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "academic_contributions",
                                        "development_for_minimum_30_min_video"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.academic_contributions
                                      ?.development_of_moocs_offering_swayam_courses_or_nittt_module
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.academic_contributions
                                      ?.development_for_minimum_30_min_video
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.academic_contributions
                                    ?.development_of_moocs_offering_swayam_courses_or_nittt_module *
                                    count?.academic_contributions
                                      ?.development_of_moocs_offering_swayam_courses_or_nittt_module
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.academic_contributions
                                    ?.development_for_minimum_30_min_video *
                                    count?.academic_contributions
                                      ?.development_for_minimum_30_min_video
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              e. Resource person in Training Programmes
                              (Institute)
                            </td>
                            <td>For 18 hours</td>
                            <td>
                              <input
                                type="number"
                                min={0}
                                max={100}
                                onKeyDown={(e) => Restrict(e)}
                                placeholder="Enter Count"
                                className="fieldinput"
                                value={
                                  apply?.academic_contributions
                                    ?.resouce_program_in_training_programmes ??
                                  0
                                }
                                onChange={(e) =>
                                  setData(
                                    e.target.value,
                                    "academic_contributions",
                                    "resouce_program_in_training_programmes"
                                  )
                                }
                                onWheelCapture={e => { e.target.blur() }}
                              />
                            </td>
                            <td>
                              {
                                count?.academic_contributions
                                  ?.resouce_program_in_training_programmes
                                  ?.per_actitity_score
                              }
                            </td>
                            <td>
                              {apply?.academic_contributions
                                ?.resouce_program_in_training_programmes *
                                count?.academic_contributions
                                  ?.resouce_program_in_training_programmes
                                  ?.per_actitity_score}
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              f. Development of Training/ Laboratory Manuals
                            </td>
                            <td>
                              Development of Training/ Laboratory Manuals
                            </td>
                            <td>
                              <input
                                type="number"
                                min={0}
                                max={100}
                                onKeyDown={(e) => Restrict(e)}
                                placeholder="Enter Count"
                                className="fieldinput"
                                value={
                                  apply?.academic_contributions
                                    ?.development_of_training_manual
                                }
                                onChange={(e) =>
                                  setData(
                                    e.target.value,
                                    "academic_contributions",
                                    "development_of_training_manual"
                                  )
                                }
                                onWheelCapture={e => { e.target.blur() }}
                              />
                            </td>
                            <td>
                              {
                                count?.academic_contributions
                                  ?.development_of_training_manual
                                  ?.per_actitity_score
                              }
                            </td>
                            <td>
                              {apply?.academic_contributions
                                ?.development_of_training_manual *
                                count?.academic_contributions
                                  ?.development_of_training_manual
                                  ?.per_actitity_score}
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              g. Courses handled for PG/ Ph.D. programme
                            </td>
                            <td>
                              Classes handled individually for a 3 credit course/ semester
                              (If classes were conducted jointly, then the score will
                              be considered proportionately based on the number of faculty members involved)

                            </td>
                            <td>
                              <input
                                type="number"
                                min={0}
                                max={100}
                                onKeyDown={(e) => Restrict(e)}
                                placeholder="Enter Count"
                                className="fieldinput"
                                value={
                                  apply?.academic_contributions
                                    ?.coursed_handled_for_pg_phd_programme
                                }
                                onChange={(e) =>
                                  setData(
                                    e.target.value,
                                    "academic_contributions",
                                    "coursed_handled_for_pg_phd_programme"
                                  )
                                }
                                onWheelCapture={e => { e.target.blur() }}
                              />
                            </td>
                            <td>
                              {
                                count?.academic_contributions
                                  ?.coursed_handled_for_pg_phd_programme
                                  ?.per_actitity_score
                              }
                            </td>
                            <td>
                              {apply?.academic_contributions
                                ?.coursed_handled_for_pg_phd_programme *
                                count?.academic_contributions
                                  ?.coursed_handled_for_pg_phd_programme
                                  ?.per_actitity_score}
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              h. New course(s) developed and offered
                            </td>
                            <td>3 credit course or its equivalent</td>
                            <td>
                              <input
                                type="number"
                                min={0}
                                max={100}
                                onKeyDown={(e) => Restrict(e)}
                                placeholder="Enter Count"
                                className="fieldinput"
                                value={
                                  apply?.academic_contributions
                                    ?.new_courses_developed_and_offered
                                }
                                onChange={(e) =>
                                  setData(
                                    e.target.value,
                                    "academic_contributions",
                                    "new_courses_developed_and_offered"
                                  )
                                }
                                onWheelCapture={e => { e.target.blur() }}
                              />
                            </td>
                            <td>
                              {
                                count?.academic_contributions
                                  ?.new_courses_developed_and_offered
                                  ?.per_actitity_score
                              }
                            </td>
                            <td>
                              {apply?.academic_contributions
                                ?.new_courses_developed_and_offered *
                                count?.academic_contributions
                                  ?.new_courses_developed_and_offered
                                  ?.per_actitity_score}
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              i. Curriculum Developed/ Revised
                            </td>
                            <td>
                              <tr>
                                <td>&lt; 3 lakhs</td>
                              </tr>
                              <br />
                              <tr>
                                <td>3 - 5 lakhs</td>
                              </tr>
                              <br />
                              <tr>
                                <td>5 - 10 lakhs</td>
                              </tr>
                              <br />
                              <tr>
                                <td>10 - 15 lakhs</td>
                              </tr>
                              <br />
                              <tr>
                                <td>&gt; 15 lakhs</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.academic_contributions
                                        ?.curriculum_developed_revised_lt_3_lakhs ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "academic_contributions",
                                        "curriculum_developed_revised_lt_3_lakhs"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.academic_contributions
                                        ?.curriculum_developed_revised_3_to_5_lakhs ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "academic_contributions",
                                        "curriculum_developed_revised_3_to_5_lakhs"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.academic_contributions
                                        ?.curriculum_developed_revised_5_to_10_lakhs ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "academic_contributions",
                                        "curriculum_developed_revised_5_to_10_lakhs"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.academic_contributions
                                        ?.curriculum_developed_revised_10_to_15_lakhs ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "academic_contributions",
                                        "curriculum_developed_revised_10_to_15_lakhs"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.academic_contributions
                                        ?.curriculum_developed_revised_gt_15_lakhs ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "academic_contributions",
                                        "curriculum_developed_revised_gt_15_lakhs"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.academic_contributions
                                      ?.curriculum_developed_revised_lt_3_lakhs
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.academic_contributions
                                      ?.curriculum_developed_revised_3_to_5_lakhs
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.academic_contributions
                                      ?.curriculum_developed_revised_5_to_10_lakhs
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.academic_contributions
                                      ?.curriculum_developed_revised_10_to_15_lakhs
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.academic_contributions
                                      ?.curriculum_developed_revised_gt_15_lakhs
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.academic_contributions
                                    ?.curriculum_developed_revised_lt_3_lakhs *
                                    count?.academic_contributions
                                      ?.curriculum_developed_revised_lt_3_lakhs
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.academic_contributions
                                    ?.curriculum_developed_revised_3_to_5_lakhs *
                                    count?.academic_contributions
                                      ?.curriculum_developed_revised_3_to_5_lakhs
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.academic_contributions
                                    ?.curriculum_developed_revised_5_to_10_lakhs *
                                    count?.academic_contributions
                                      ?.curriculum_developed_revised_5_to_10_lakhs
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.academic_contributions
                                    ?.curriculum_developed_revised_10_to_15_lakhs *
                                    count?.academic_contributions
                                      ?.curriculum_developed_revised_10_to_15_lakhs
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.academic_contributions
                                    ?.curriculum_developed_revised_gt_15_lakhs *
                                    count?.academic_contributions
                                      ?.curriculum_developed_revised_gt_15_lakhs
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">Total</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              {apply?.academic_contributions
                                ?.non_sponsored_training *
                                count?.academic_contributions
                                  ?.non_sponsored_training?.per_actitity_score +


                                apply?.academic_contributions
                                  ?.training_programmes_conducted *
                                count?.academic_contributions
                                  ?.training_programmes_conducted
                                  ?.per_actitity_score +


                                apply?.academic_contributions
                                  ?.aid_training_programmes_lt_3_lakhs *
                                count?.academic_contributions
                                  ?.aid_training_programmes_lt_3_lakhs
                                  ?.per_actitity_score +



                                apply?.academic_contributions
                                  ?.aid_training_programmes_3_t0_5_lakhs *
                                count?.academic_contributions
                                  ?.aid_training_programmes_3_t0_5_lakhs
                                  ?.per_actitity_score +









                                apply?.academic_contributions
                                  ?.aid_training_programmes_gt_5_lakhs *
                                count?.academic_contributions
                                  ?.aid_training_programmes_gt_5_lakhs
                                  ?.per_actitity_score +




                                apply?.academic_contributions
                                  ?.sponsored_contact_mode_for_coordinator_training *
                                count?.academic_contributions
                                  ?.sponsored_contact_mode_for_coordinator_training
                                  ?.per_actitity_score +


                                apply?.academic_contributions
                                  ?.sponsored_contact_mode_for_co_coordinator_training *
                                count?.academic_contributions
                                  ?.sponsored_contact_mode_for_co_coordinator_training
                                  ?.per_actitity_score +
                                apply?.academic_contributions
                                  ?.skill_development_for_coordinator_training *
                                count?.academic_contributions
                                  ?.skill_development_for_coordinator_training
                                  ?.per_actitity_score +
                                apply?.academic_contributions
                                  ?.skill_development_for_co_coordinator_training *
                                count?.academic_contributions
                                  ?.skill_development_for_co_coordinator_training
                                  ?.per_actitity_score +
                                apply?.academic_contributions
                                  ?.development_of_moocs_offering_swayam_courses_or_nittt_module *
                                count?.academic_contributions
                                  ?.development_of_moocs_offering_swayam_courses_or_nittt_module
                                  ?.per_actitity_score +
                                apply?.academic_contributions
                                  ?.development_for_minimum_30_min_video *
                                count?.academic_contributions
                                  ?.development_for_minimum_30_min_video
                                  ?.per_actitity_score +
                                apply?.academic_contributions
                                  ?.resouce_program_in_training_programmes *
                                count?.academic_contributions
                                  ?.resouce_program_in_training_programmes
                                  ?.per_actitity_score +
                                apply?.academic_contributions
                                  ?.development_of_training_manual *
                                count?.academic_contributions
                                  ?.development_of_training_manual
                                  ?.per_actitity_score +
                                apply?.academic_contributions
                                  ?.coursed_handled_for_pg_phd_programme *
                                count?.academic_contributions
                                  ?.coursed_handled_for_pg_phd_programme
                                  ?.per_actitity_score +
                                apply?.academic_contributions
                                  ?.new_courses_developed_and_offered *
                                count?.academic_contributions
                                  ?.new_courses_developed_and_offered
                                  ?.per_actitity_score +
                                apply?.academic_contributions
                                  ?.curriculum_developed_revised_lt_3_lakhs *
                                count?.academic_contributions
                                  ?.curriculum_developed_revised_lt_3_lakhs
                                  ?.per_actitity_score +
                                apply?.academic_contributions
                                  ?.curriculum_developed_revised_3_to_5_lakhs *
                                count?.academic_contributions
                                  ?.curriculum_developed_revised_3_to_5_lakhs
                                  ?.per_actitity_score +
                                apply?.academic_contributions
                                  ?.curriculum_developed_revised_5_to_10_lakhs *
                                count?.academic_contributions
                                  ?.curriculum_developed_revised_5_to_10_lakhs
                                  ?.per_actitity_score +
                                apply?.academic_contributions
                                  ?.curriculum_developed_revised_10_to_15_lakhs *
                                count?.academic_contributions
                                  ?.curriculum_developed_revised_10_to_15_lakhs
                                  ?.per_actitity_score +
                                apply?.academic_contributions
                                  ?.curriculum_developed_revised_gt_15_lakhs *
                                count?.academic_contributions
                                  ?.curriculum_developed_revised_gt_15_lakhs
                                  ?.per_actitity_score}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}
                  {active === 1 && (
                    <>
                      <h5 className="centertext my-5">
                        RESEARCH CONTRIBUTIONS
                      </h5>
                      <table className="tablereport table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">Topic</th>
                            <th scope="col">Criteria</th>
                            <th scope="col">Target Fixed </th>
                            <th scope="col">Score/Item </th>
                            <th scope="col">Score Fixed</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="tablewidth">
                              a. Ph.D. research scholars guided
                            </td>
                            <td>Degree awarded</td>
                            <td>
                              <tr> <td>
                                <input
                                  type="number"
                                  min={0}
                                  max={100}
                                  onKeyDown={(e) => Restrict(e)}
                                  pattern="[0-9]*"
                                  placeholder="Enter Count"
                                  className="fieldinput"
                                  value={
                                    apply?.research_contributions
                                      ?.phd_research_guidance
                                  }
                                  onChange={(e) =>
                                    setData(
                                      e.target.value,
                                      "research_contributions",
                                      "phd_research_guidance"
                                    )
                                  }
                                  onWheelCapture={e => { e.target.blur() }}
                                /></td></tr>

                            </td>
                            <td>
                              {
                                count?.research_contributions
                                  ?.phd_research_guidance?.per_actitity_score
                              }
                            </td>
                            <td>
                              {apply?.research_contributions
                                ?.phd_research_guidance *
                                count?.research_contributions
                                  ?.phd_research_guidance?.per_actitity_score}
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              b. Post Graduate thesis guided
                            </td>
                            <td>Degree awarded</td>
                            <td>
                              <tr><td>
                                <input
                                  type="number"
                                  min={0}
                                  max={100}
                                  onKeyDown={(e) => Restrict(e)}
                                  placeholder="Enter Count"
                                  className="fieldinput"
                                  value={
                                    apply?.research_contributions
                                      ?.post_graduate_thesis_guidance
                                  }
                                  onChange={(e) =>
                                    setData(
                                      e.target.value,
                                      "research_contributions",
                                      "post_graduate_thesis_guidance"
                                    )
                                  }
                                  onWheelCapture={e => { e.target.blur() }}
                                /></td></tr>

                            </td>
                            <td>
                              {
                                count?.research_contributions
                                  ?.post_graduate_thesis_guidance
                                  ?.per_actitity_score
                              }
                            </td>
                            <td>
                              {apply?.research_contributions
                                ?.post_graduate_thesis_guidance *
                                count?.research_contributions
                                  ?.post_graduate_thesis_guidance
                                  ?.per_actitity_score}
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              c. Sponsored research projects carried out
                            </td>
                            <td>
                              <tr>
                                <td>Submitted</td>
                              </tr>
                              <br />
                              <tr>
                                <td>&lt; 5 lakhs</td>
                              </tr>
                              <br />
                              <tr>
                                <td>5 - 15 lakhs</td>
                              </tr>
                              <br />
                              <tr>
                                <td>&gt; 15 lakhs</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.sponsored_research_projects_submitted ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "sponsored_research_projects_submitted"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.sponsored_research_projects_lt_5_lakhs ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "sponsored_research_projects_lt_5_lakhs"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.sponsored_research_projects_5_to_15_lakhs ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "sponsored_research_projects_5_to_15_lakhs"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.sponsored_research_projects_gt_15_lakhs ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "sponsored_research_projects_gt_15_lakhs"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.sponsored_research_projects_submitted
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.sponsored_research_projects_lt_5_lakhs
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.sponsored_research_projects_5_to_15_lakhs
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.sponsored_research_projects_gt_15_lakhs
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.sponsored_research_projects_submitted *
                                    count?.research_contributions
                                      ?.sponsored_research_projects_submitted
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.sponsored_research_projects_lt_5_lakhs *
                                    count?.research_contributions
                                      ?.sponsored_research_projects_lt_5_lakhs
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.sponsored_research_projects_5_to_15_lakhs *
                                    count?.research_contributions
                                      ?.sponsored_research_projects_5_to_15_lakhs
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.sponsored_research_projects_gt_15_lakhs *
                                    count?.research_contributions
                                      ?.sponsored_research_projects_gt_15_lakhs
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              d. Consultancy works carried out based on the requirements of the Clientele system.
                            </td>
                            <td>
                              <tr>
                                <td>&lt; 3 lakhs</td>
                              </tr>
                              <br />
                              <tr>
                                <td>3 - 5 lakhs</td>
                              </tr>
                              <br />
                              <tr>
                                <td>&gt; 5 lakhs</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.consultancy_works_carried_out_lt_3_lakhs ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "consultancy_works_carried_out_lt_3_lakhs"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.consultancy_works_carried_out_3_to_5_lakhs ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "consultancy_works_carried_out_3_to_5_lakhs"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.consultancy_works_carried_out_gt_5_lakhs ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "consultancy_works_carried_out_gt_5_lakhs"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.consultancy_works_carried_out_lt_3_lakhs
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.consultancy_works_carried_out_3_to_5_lakhs
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.consultancy_works_carried_out_gt_5_lakhs
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.consultancy_works_carried_out_lt_3_lakhs *
                                    count?.research_contributions
                                      ?.consultancy_works_carried_out_lt_3_lakhs
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.consultancy_works_carried_out_3_to_5_lakhs *
                                    count?.research_contributions
                                      ?.consultancy_works_carried_out_3_to_5_lakhs
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.consultancy_works_carried_out_gt_5_lakhs *
                                    count?.research_contributions
                                      ?.consultancy_works_carried_out_gt_5_lakhs
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              e. Research publications in referred
                              journals only as first/ corresponding
                              author (For more than one author, the
                              score for other authors will be 50%)
                            </td>
                            <td>
                              <tr>
                                <td>SCI</td>
                              </tr>
                              <br />
                              <tr>
                                <td>Scopus indexed</td>
                              </tr>
                              <br />
                              <tr>
                                <td>UGC listed</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.research_publications_in_sci
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "research_publications_in_sci"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.research_publications_in_scopus_indexed ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "research_publications_in_scopus_indexed"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.research_publications_in_ugc_listed ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "research_publications_in_ugc_listed"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.research_publications_in_sci
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.research_publications_in_scopus_indexed
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.research_publications_in_ugc_listed
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.research_publications_in_sci *
                                    count?.research_contributions
                                      ?.research_publications_in_sci
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.research_publications_in_scopus_indexed *
                                    count?.research_contributions
                                      ?.research_publications_in_scopus_indexed
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.research_publications_in_ugc_listed *
                                    count?.research_contributions
                                      ?.research_publications_in_ugc_listed
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              f. Papers presented in national/ international
                              conference/ seminar
                            </td>
                            <td>
                              <tr>
                                <td>International</td>
                              </tr>
                              <br />
                              <tr>
                                <td>National</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.paper_presented_in_international
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "paper_presented_in_international"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.paper_presented_in_national
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "paper_presented_in_national"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.paper_presented_in_international
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.paper_presented_in_national
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.paper_presented_in_international *
                                    count?.research_contributions
                                      ?.paper_presented_in_international
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.paper_presented_in_national *
                                    count?.research_contributions
                                      ?.paper_presented_in_national
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              g. Books Authored/ Edited book/ edited
                              proceedings/ book chapter/ monographs (only with
                              ISBN/ ISSN) (as first author, for more than one author, the score for other authors will be 50%)
                            </td>
                            <td>
                              <tr>
                                <td>Books - International Publisher</td>
                              </tr>
                              <br />
                              <tr>
                                <td>Books - National Publisher</td>
                              </tr>
                              <br />
                              <tr>
                                <td>Book Chapter - International Publisher</td>
                              </tr>
                              <br />
                              <tr>
                                <td>Book Chapter - National Publisher</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.books_international_publisher
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "books_international_publisher"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.books_national_publisher
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "books_national_publisher"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.book_chapter_international_publisher ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "book_chapter_international_publisher"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.book_chapter_national_publisher
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "book_chapter_national_publisher"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.books_international_publisher
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.books_national_publisher
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.book_chapter_international_publisher
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.book_chapter_national_publisher
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.books_international_publisher *
                                    count?.research_contributions
                                      ?.books_international_publisher
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.books_national_publisher *
                                    count?.research_contributions
                                      ?.books_national_publisher
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.book_chapter_international_publisher *
                                    count?.research_contributions
                                      ?.book_chapter_international_publisher
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.book_chapter_national_publisher *
                                    count?.research_contributions
                                      ?.book_chapter_national_publisher
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              h. Patents, copy right and technology transfer
                              agreements signed
                            </td>
                            <td>
                              <tr>
                                <td>Granted - International</td>
                              </tr>
                              <br />
                              <tr>
                                <td>Granted - National</td>
                              </tr>
                              <br />
                              <tr>
                                <td>Published - International</td>
                              </tr>
                              <br />
                              <tr>
                                <td>Published - National</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.patents_granted_international
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "patents_granted_international"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.patents_granted
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "patents_granted"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.patents_filed_international
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "patents_filed_international"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.patents_filed
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "patents_filed"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.patents_granted_international
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.patents_granted?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.patents_filed_international
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions?.patents_filed
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.patents_granted_international *
                                    count?.research_contributions
                                      ?.patents_granted_international
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.patents_granted *
                                    count?.research_contributions
                                      ?.patents_granted?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.patents_filed_international *
                                    count?.research_contributions
                                      ?.patents_filed_international
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.patents_filed *
                                    count?.research_contributions?.patents_filed
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              i. Honors/ awards/ medals/ fellowships for
                              outstanding contributions
                            </td>
                            <td>
                              <tr>
                                <td>International</td>
                              </tr>
                              <br />
                              <tr>
                                <td>National</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.international_awards
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "international_awards"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.research_contributions
                                        ?.national_awards
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "research_contributions",
                                        "national_awards"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.international_awards?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.research_contributions
                                      ?.national_awards?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.international_awards *
                                    count?.research_contributions
                                      ?.international_awards
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.research_contributions
                                    ?.national_awards *
                                    count?.research_contributions
                                      ?.national_awards?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">Total</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              {apply?.research_contributions
                                ?.phd_research_guidance *
                                count?.research_contributions
                                  ?.phd_research_guidance?.per_actitity_score +
                                apply?.research_contributions
                                  ?.post_graduate_thesis_guidance *
                                count?.research_contributions
                                  ?.post_graduate_thesis_guidance
                                  ?.per_actitity_score +
                                apply?.research_contributions
                                  ?.sponsored_research_projects_submitted *
                                count?.research_contributions
                                  ?.sponsored_research_projects_submitted
                                  ?.per_actitity_score +
                                apply?.research_contributions
                                  ?.sponsored_research_projects_lt_5_lakhs *
                                count?.research_contributions
                                  ?.sponsored_research_projects_lt_5_lakhs
                                  ?.per_actitity_score +
                                apply?.research_contributions
                                  ?.sponsored_research_projects_5_to_15_lakhs *
                                count?.research_contributions
                                  ?.sponsored_research_projects_5_to_15_lakhs
                                  ?.per_actitity_score +
                                apply?.research_contributions
                                  ?.sponsored_research_projects_gt_15_lakhs *
                                count?.research_contributions
                                  ?.sponsored_research_projects_gt_15_lakhs
                                  ?.per_actitity_score +
                                apply?.research_contributions
                                  ?.consultancy_works_carried_out_lt_3_lakhs *
                                count?.research_contributions
                                  ?.consultancy_works_carried_out_lt_3_lakhs
                                  ?.per_actitity_score +
                                apply?.research_contributions
                                  ?.consultancy_works_carried_out_3_to_5_lakhs *
                                count?.research_contributions
                                  ?.consultancy_works_carried_out_3_to_5_lakhs
                                  ?.per_actitity_score +
                                apply?.research_contributions
                                  ?.consultancy_works_carried_out_gt_5_lakhs *
                                count?.research_contributions
                                  ?.consultancy_works_carried_out_gt_5_lakhs
                                  ?.per_actitity_score +
                                apply?.research_contributions
                                  ?.research_publications_in_sci *
                                count?.research_contributions
                                  ?.research_publications_in_sci
                                  ?.per_actitity_score +
                                apply?.research_contributions
                                  ?.research_publications_in_scopus_indexed *
                                count?.research_contributions
                                  ?.research_publications_in_scopus_indexed
                                  ?.per_actitity_score +
                                apply?.research_contributions
                                  ?.research_publications_in_ugc_listed *
                                count?.research_contributions
                                  ?.research_publications_in_ugc_listed
                                  ?.per_actitity_score +
                                apply?.research_contributions
                                  ?.paper_presented_in_international *
                                count?.research_contributions
                                  ?.paper_presented_in_international
                                  ?.per_actitity_score +
                                apply?.research_contributions
                                  ?.paper_presented_in_national *
                                count?.research_contributions
                                  ?.paper_presented_in_national
                                  ?.per_actitity_score +
                                apply?.research_contributions
                                  ?.books_international_publisher *
                                count?.research_contributions
                                  ?.books_international_publisher
                                  ?.per_actitity_score +
                                apply?.research_contributions
                                  ?.books_national_publisher *
                                count?.research_contributions
                                  ?.books_national_publisher
                                  ?.per_actitity_score +
                                apply?.research_contributions
                                  ?.book_chapter_international_publisher *
                                count?.research_contributions
                                  ?.book_chapter_international_publisher
                                  ?.per_actitity_score +
                                apply?.research_contributions
                                  ?.book_chapter_national_publisher *
                                count?.research_contributions
                                  ?.book_chapter_national_publisher
                                  ?.per_actitity_score +
                                apply?.research_contributions?.patents_granted *
                                count?.research_contributions?.patents_granted
                                  ?.per_actitity_score +
                                apply?.research_contributions?.patents_filed *
                                count?.research_contributions?.patents_filed
                                  ?.per_actitity_score +
                                apply?.research_contributions
                                  ?.patents_granted_international *
                                count?.research_contributions
                                  ?.patents_granted_international
                                  ?.per_actitity_score +
                                apply?.research_contributions
                                  ?.patents_filed_international *
                                count?.research_contributions
                                  ?.patents_filed_international
                                  ?.per_actitity_score +
                                apply?.research_contributions
                                  ?.international_awards *
                                count?.research_contributions
                                  ?.international_awards?.per_actitity_score +
                                apply?.research_contributions?.national_awards *
                                count?.research_contributions?.national_awards
                                  ?.per_actitity_score}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}
                  {active === 2 && (
                    <>
                      <h5 className="centertext my-5">
                        INSTITUTIONAL DEVELOPMENT
                      </h5>
                      <table className="tablereport table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">Topic</th>

                            <th scope="col">Criteria</th>

                            <th scope="col">Target Fixed </th>

                            <th scope="col">Score/Item </th>

                            <th scope="col">Score Fixed</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="tablewidth">
                              a. Administrative contributions (subject to the
                              conduct of atleast two meetings in 6 months)
                            </td>
                            <td>
                              <tr>
                                <td>
                                  HOD/ In charge/ Chairman of the Committee
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>Member of Committee</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.institutional_development
                                        ?.administrative_contributions_hod_of_the_committee ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "institutional_development",
                                        "administrative_contributions_hod_of_the_committee"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.institutional_development
                                        ?.administrative_contributions_member_of_the_committee ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "institutional_development",
                                        "administrative_contributions_member_of_the_committee"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.institutional_development
                                      ?.administrative_contributions_hod_of_the_committee
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.institutional_development
                                      ?.administrative_contributions_member_of_the_committee
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.institutional_development
                                    ?.administrative_contributions_hod_of_the_committee *
                                    count?.institutional_development
                                      ?.administrative_contributions_hod_of_the_committee
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.institutional_development
                                    ?.administrative_contributions_member_of_the_committee *
                                    count?.institutional_development
                                      ?.administrative_contributions_member_of_the_committee
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              b. Infrastructure developed with internal/
                              external funding for improvement in science and
                              technology
                            </td>
                            <td>
                              <tr>
                                <td>Internal Funding more than 10 lakhs</td>
                              </tr>
                              <br />
                              <tr>
                                <td>External Funding upto 5 lakhs</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.institutional_development
                                        ?.infrastructure_development_internal_funding_upto_10_lakhs ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "institutional_development",
                                        "infrastructure_development_internal_funding_upto_10_lakhs"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.institutional_development
                                        ?.infrastructure_development_external_funding_upto_5_lakhs ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "institutional_development",
                                        "infrastructure_development_external_funding_upto_5_lakhs"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.institutional_development
                                      ?.infrastructure_development_internal_funding_upto_10_lakhs
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.institutional_development
                                      ?.infrastructure_development_external_funding_upto_5_lakhs
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.institutional_development
                                    ?.infrastructure_development_internal_funding_upto_10_lakhs *
                                    count?.institutional_development
                                      ?.infrastructure_development_internal_funding_upto_10_lakhs
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.institutional_development
                                    ?.infrastructure_development_external_funding_upto_5_lakhs *
                                    count?.institutional_development
                                      ?.infrastructure_development_external_funding_upto_5_lakhs
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          {/* <tr>
                                                        <td className="tablewidth">
                                                            c. Revenue generated through Training Programmes
                                                            as Co-ordinator/ Other Avenues
                                                        </td>
                                                        <td>
                                                            <tr>
                                                                <td>&lt; 3 lakhs</td>
                                                            </tr>
                                                            <br />
                                                            <tr>
                                                                <td>3 - 5 lakhs</td>
                                                            </tr>
                                                            <br />
                                                            <tr>
                                                                <td>&gt; 5 lakhs</td>
                                                            </tr>
                                                        </td>
                                                        <td>
                                                            <tr>
                                                                <td>
                                                                    <input
                                                                         type="number"
 min={0}
max={100}
onKeyDown={(e) => Restrict(e)}
                                                                        placeholder="Enter Count"
                                                                        className="fieldinput"
                                                                        value={
                                                                            apply?.institutional_development
                                                                                ?.revenue_generated_through_training_programmes_lt_3_lakhs ??
                                                                            0
                                                                        }
                                                                        onChange={(e) =>
                                                                            setData(
                                                                                e.target.value,
                                                                                "institutional_development",
                                                                                "revenue_generated_through_training_programmes_lt_3_lakhs"
                                                                            )
                                                                        }
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <input
                                                                         type="number"
 min={0}
max={100}
onKeyDown={(e) => Restrict(e)}
                                                                        placeholder="Enter Count"
                                                                        className="fieldinput"
                                                                        value={
                                                                            apply?.institutional_development
                                                                                ?.revenue_generated_through_training_programmes_3_to_5_lakhs ??
                                                                            0
                                                                        }
                                                                        onChange={(e) =>
                                                                            setData(
                                                                                e.target.value,
                                                                                "institutional_development",
                                                                                "revenue_generated_through_training_programmes_3_to_5_lakhs"
                                                                            )
                                                                        }
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <input
                                                                         type="number"
 min={0}
max={100}
onKeyDown={(e) => Restrict(e)}
                                                                        placeholder="Enter Count"
                                                                        className="fieldinput"
                                                                        value={
                                                                            apply?.institutional_development
                                                                                ?.revenue_generated_through_training_programmes_gt_5_lakhs ??
                                                                            0
                                                                        }
                                                                        onChange={(e) =>
                                                                            setData(
                                                                                e.target.value,
                                                                                "institutional_development",
                                                                                "revenue_generated_through_training_programmes_gt_5_lakhs"
                                                                            )
                                                                        }
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </td>
                                                        <td>
                                                            <tr>
                                                                <td>
                                                                    {
                                                                        count?.institutional_development
                                                                            ?.revenue_generated_through_training_programmes_lt_3_lakhs?.per_actitity_score
                                                                    }
                                                                </td>
                                                            </tr>
                                                            <br />
                                                            <tr>
                                                                <td>
                                                                    {
                                                                        count?.institutional_development
                                                                            ?.revenue_generated_through_training_programmes_3_to_5_lakhs?.per_actitity_score
                                                                    }
                                                                </td>
                                                            </tr>
                                                            <br />
                                                            <tr>
                                                                <td>
                                                                    {
                                                                        count?.institutional_development
                                                                            ?.revenue_generated_through_training_programmes_gt_5_lakhs?.per_actitity_score
                                                                    }
                                                                </td>
                                                            </tr>
                                                        </td>
                                                        <td>
                                                            <tr>
                                                                <td>
                                                                    {apply?.institutional_development
                                                                        ?.revenue_generated_through_training_programmes_lt_3_lakhs *
                                                                        count?.institutional_development
                                                                            ?.revenue_generated_through_training_programmes_lt_3_lakhs?.per_actitity_score}
                                                                </td>
                                                            </tr>
                                                            <br />
                                                            <tr>
                                                                <td>
                                                                    {apply?.institutional_development
                                                                        ?.revenue_generated_through_training_programmes_3_to_5_lakhs *
                                                                        count?.institutional_development
                                                                            ?.revenue_generated_through_training_programmes_3_to_5_lakhs?.per_actitity_score}
                                                                </td>
                                                            </tr>
                                                            <br />
                                                            <tr>
                                                                <td>
                                                                    {apply?.institutional_development
                                                                        ?.revenue_generated_through_training_programmes_gt_5_lakhs *
                                                                        count?.institutional_development
                                                                            ?.revenue_generated_through_training_programmes_gt_5_lakhs?.per_actitity_score}
                                                                </td>
                                                            </tr>
                                                        </td>
                                                    </tr> */}
                          <tr>
                            <td className="tablewidth">
                              c. Research/ academic events (workshop/
                              conference/ seminar/ webinar/ programmes under
                              national initiatives) organized at national/
                              international level as Coordinator (Score for the
                              webinar will be 20% of workshop/ conference/
                              seminar; Score for the Co-coordinator of workshop/
                              conference/ seminar will be 50%)
                            </td>
                            <td>
                              <tr>
                                <td>
                                  International/ Programmes under national
                                  initiatives
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>National</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.institutional_development
                                        ?.research_or_academic_events_international ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "institutional_development",
                                        "research_or_academic_events_international"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.institutional_development
                                        ?.research_or_academic_events_national ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "institutional_development",
                                        "research_or_academic_events_national"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.institutional_development
                                      ?.research_or_academic_events_international
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.institutional_development
                                      ?.research_or_academic_events_national
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.institutional_development
                                    ?.research_or_academic_events_international *
                                    count?.institutional_development
                                      ?.research_or_academic_events_international
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.institutional_development
                                    ?.research_or_academic_events_national *
                                    count?.institutional_development
                                      ?.research_or_academic_events_national
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              d. Events conducted in collaboration with Industry
                            </td>
                            <td>
                              <tr>
                                <td>With Revenue Generation</td>
                              </tr>
                              <br />
                              <tr>
                                <td>Without Revenue Generation</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.institutional_development
                                        ?.events_conducted_with_revenue_generation ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "institutional_development",
                                        "events_conducted_with_revenue_generation"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.institutional_development
                                        ?.events_conducted_without_revenue_generation ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "institutional_development",
                                        "events_conducted_without_revenue_generation"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.institutional_development
                                      ?.events_conducted_with_revenue_generation
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.institutional_development
                                      ?.events_conducted_without_revenue_generation
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.institutional_development
                                    ?.events_conducted_with_revenue_generation *
                                    count?.institutional_development
                                      ?.events_conducted_with_revenue_generation
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.institutional_development
                                    ?.events_conducted_without_revenue_generation *
                                    count?.institutional_development
                                      ?.events_conducted_without_revenue_generation
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              e. New initiatives implemented for the Institute
                              Development:
                            </td>
                            <td>
                              <tr>
                                <td>With Revenue Generation</td>
                              </tr>
                              <br />
                              <tr>
                                <td>Without Revenue Generation</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.institutional_development
                                        ?.new_initiatives_implemented_with_revenue_generation ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "institutional_development",
                                        "new_initiatives_implemented_with_revenue_generation"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.institutional_development
                                        ?.new_initiatives_implemented_without_revenue_generation ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "institutional_development",
                                        "new_initiatives_implemented_without_revenue_generation"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.institutional_development
                                      ?.new_initiatives_implemented_with_revenue_generation
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.institutional_development
                                      ?.new_initiatives_implemented_without_revenue_generation
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.institutional_development
                                    ?.new_initiatives_implemented_with_revenue_generation *
                                    count?.institutional_development
                                      ?.new_initiatives_implemented_with_revenue_generation
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.institutional_development
                                    ?.new_initiatives_implemented_without_revenue_generation *
                                    count?.institutional_development
                                      ?.new_initiatives_implemented_without_revenue_generation
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">Total</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              {apply?.institutional_development
                                ?.administrative_contributions_hod_of_the_committee *
                                count?.institutional_development
                                  ?.administrative_contributions_hod_of_the_committee
                                  ?.per_actitity_score +
                                apply?.institutional_development
                                  ?.administrative_contributions_member_of_the_committee *
                                count?.institutional_development
                                  ?.administrative_contributions_member_of_the_committee
                                  ?.per_actitity_score +
                                apply?.institutional_development
                                  ?.infrastructure_development_internal_funding_upto_10_lakhs *
                                count?.institutional_development
                                  ?.infrastructure_development_internal_funding_upto_10_lakhs
                                  ?.per_actitity_score +
                                apply?.institutional_development
                                  ?.infrastructure_development_external_funding_upto_5_lakhs *
                                count?.institutional_development
                                  ?.infrastructure_development_external_funding_upto_5_lakhs
                                  ?.per_actitity_score +
                                // apply?.institutional_development
                                //     ?.revenue_generated_through_training_programmes_lt_3_lakhs *
                                // count?.institutional_development
                                //     ?.revenue_generated_through_training_programmes_lt_3_lakhs?.per_actitity_score +
                                // apply?.institutional_development
                                //     ?.revenue_generated_through_training_programmes_3_to_5_lakhs *
                                // count?.institutional_development
                                //     ?.revenue_generated_through_training_programmes_3_to_5_lakhs?.per_actitity_score +
                                // apply?.institutional_development
                                //     ?.revenue_generated_through_training_programmes_gt_5_lakhs *
                                // count?.institutional_development
                                //     ?.revenue_generated_through_training_programmes_gt_5_lakhs?.per_actitity_score
                                +apply?.institutional_development
                                  ?.research_or_academic_events_international *
                                count?.institutional_development
                                  ?.research_or_academic_events_international
                                  ?.per_actitity_score +
                                apply?.institutional_development
                                  ?.research_or_academic_events_national *
                                count?.institutional_development
                                  ?.research_or_academic_events_national
                                  ?.per_actitity_score +
                                apply?.institutional_development
                                  ?.events_conducted_with_revenue_generation *
                                count?.institutional_development
                                  ?.events_conducted_with_revenue_generation
                                  ?.per_actitity_score +
                                apply?.institutional_development
                                  ?.events_conducted_without_revenue_generation *
                                count?.institutional_development
                                  ?.events_conducted_without_revenue_generation
                                  ?.per_actitity_score +
                                apply?.institutional_development
                                  ?.new_initiatives_implemented_with_revenue_generation *
                                count?.institutional_development
                                  ?.new_initiatives_implemented_with_revenue_generation
                                  ?.per_actitity_score +
                                apply?.institutional_development
                                  ?.new_initiatives_implemented_without_revenue_generation *
                                count?.institutional_development
                                  ?.new_initiatives_implemented_without_revenue_generation
                                  ?.per_actitity_score}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}
                  {active === 3 && (
                    <>
                      <h5 className="centertext my-5">
                        PROFESSIONAL CONTRIBUTIONS
                      </h5>
                      <table className="tablereport table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">Topic</th>
                            <th scope="col">Criteria</th>
                            <th scope="col">Target Fixed </th>
                            <th scope="col">Score/Item </th>
                            <th scope="col">Score Fixed</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="tablewidth">
                              a. Resource person in Training Programmes/
                              Workshops (External)
                            </td>
                            <td>
                              <tr>
                                <td>For 12 hours</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.resource_person_in_training_programmes ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "resource_person_in_training_programmes"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.resource_person_in_training_programmes
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.resource_person_in_training_programmes *
                                    count?.professional_contributions
                                      ?.resource_person_in_training_programmes
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              b. Training programmes attended
                            </td>
                            <td>
                              <tr>
                                <td>International</td>
                              </tr>
                              <br />
                              <tr>
                                <td>National</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.training_programmes_attended_international ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "training_programmes_attended_international"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.training_programmes_attended_national ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "training_programmes_attended_national"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.training_programmes_attended_international
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.training_programmes_attended_national
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.training_programmes_attended_international *
                                    count?.professional_contributions
                                      ?.training_programmes_attended_international
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.training_programmes_attended_national *
                                    count?.professional_contributions
                                      ?.training_programmes_attended_national
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              c. Participation and academic contributions in the
                              area of your academic and professional expertise
                              at International/ National/ State Level
                            </td>
                            <td>
                              <tr>
                                <td>International</td>
                              </tr>
                              <br />
                              <tr>
                                <td>National</td>
                              </tr>
                              <br />
                              <tr>
                                <td>State</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.participation_and_academic_contributions_international ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "participation_and_academic_contributions_international"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.participation_and_academic_contributions_national ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "participation_and_academic_contributions_national"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.participation_and_academic_contributions_state ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "participation_and_academic_contributions_state"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.participation_and_academic_contributions_international
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.participation_and_academic_contributions_national
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.participation_and_academic_contributions_state
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.participation_and_academic_contributions_international *
                                    count?.professional_contributions
                                      ?.participation_and_academic_contributions_international
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.participation_and_academic_contributions_national *
                                    count?.professional_contributions
                                      ?.participation_and_academic_contributions_national
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.participation_and_academic_contributions_state *
                                    count?.professional_contributions
                                      ?.participation_and_academic_contributions_state
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              d. Overseas visited for Academic Events/ Plenary
                              Lectures/ Invited Talks/ Part of Delegation/
                              Others
                            </td>
                            <td>
                              <tr>
                                <td>
                                  academic events/ plenary lectures/ invited
                                  talks/
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>Part of delegation</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.overseas_visited_for_academic_events ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "overseas_visited_for_academic_events"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.overseas_visited_for_part_of_delegation ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "overseas_visited_for_part_of_delegation"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.overseas_visited_for_academic_events
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.overseas_visited_for_part_of_delegation
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.overseas_visited_for_academic_events *
                                    count?.professional_contributions
                                      ?.overseas_visited_for_academic_events
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.overseas_visited_for_part_of_delegation *
                                    count?.professional_contributions
                                      ?.overseas_visited_for_part_of_delegation
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              e. Participation and contributions in the area of
                              your academic and professional expertise
                            </td>
                            <td>
                              <tr>
                                <td>PG Examiner</td>
                              </tr>
                              <br />
                              <tr>
                                <td>Doctoral Committee member</td>
                              </tr>
                              <br />
                              <tr>
                                <td>Ph.D. Examiner</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.participation_and_contributions_in_pg_examiner ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "participation_and_contributions_in_pg_examiner"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.participation_and_contributions_in_doctoral_committee ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "participation_and_contributions_in_doctoral_committee"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.participation_and_contributions_in_phd_examiner ??
                                      0
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "participation_and_contributions_in_phd_examiner"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.participation_and_contributions_in_pg_examiner
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.participation_and_contributions_in_doctoral_committee
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.participation_and_contributions_in_phd_examiner
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.participation_and_contributions_in_pg_examiner *
                                    count?.professional_contributions
                                      ?.participation_and_contributions_in_pg_examiner
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.participation_and_contributions_in_doctoral_committee *
                                    count?.professional_contributions
                                      ?.participation_and_contributions_in_doctoral_committee
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.participation_and_contributions_in_phd_examiner *
                                    count?.professional_contributions
                                      ?.participation_and_contributions_in_phd_examiner
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              f. Editor-in-Chief/ Editorial Board Member/ Peer
                              Reviewer/ Others
                            </td>
                            <td>
                              <tr>
                                <td>Editor-in-chief (SCI)</td>
                              </tr>
                              <br />
                              <tr>
                                <td>Editor-in-chief (Scopus)</td>
                              </tr>
                              <br />
                              <tr>
                                <td>Editorial board member (SCI)</td>
                              </tr>
                              <br />
                              <tr>
                                <td>Editorial board member (Scopus)</td>
                              </tr>
                              <br />
                              <tr>
                                <td>Peer reviewer (SCI)</td>
                              </tr>
                              <br />
                              <tr>
                                <td>Peer reviewer (Scopus)</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.editor_in_cheif_sci
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "editor_in_cheif_sci"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.editor_in_cheif_scopus
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "editor_in_cheif_scopus"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.editorial_board_member_sci
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "editorial_board_member_sci"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.editorial_board_member_scopus
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "editorial_board_member_scopus"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.peer_reviewer_sci
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "peer_reviewer_sci"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.peer_reviewer_scopus
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "peer_reviewer_scopus"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.editor_in_cheif_sci?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.editor_in_cheif_scopus
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.editorial_board_member_sci
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.editorial_board_member_scopus
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.peer_reviewer_sci?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.peer_reviewer_scopus?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.editor_in_cheif_sci *
                                    count?.professional_contributions
                                      ?.editor_in_cheif_sci?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.editor_in_cheif_scopus *
                                    count?.professional_contributions
                                      ?.editor_in_cheif_scopus
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.editorial_board_member_sci *
                                    count?.professional_contributions
                                      ?.editorial_board_member_sci
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.editorial_board_member_scopus *
                                    count?.professional_contributions
                                      ?.editorial_board_member_scopus
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.peer_reviewer_sci *
                                    count?.professional_contributions
                                      ?.peer_reviewer_sci?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.peer_reviewer_scopus *
                                    count?.professional_contributions
                                      ?.peer_reviewer_scopus
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              g. National/ International academic assignment for
                              more than 1 year (Full-time)
                            </td>
                            <td>
                              <tr>
                                <td>International</td>
                              </tr>
                              <br />
                              <tr>
                                <td>National</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.international_academic_assignment
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "international_academic_assignment"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.national_academic_assignment
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "national_academic_assignment"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.international_academic_assignment
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.national_academic_assignment
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.international_academic_assignment *
                                    count?.professional_contributions
                                      ?.international_academic_assignment
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.national_academic_assignment *
                                    count?.professional_contributions
                                      ?.national_academic_assignment
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">
                              h. Fellow/ Life Member/ Member of Professional
                              Bodies/ Societies
                            </td>
                            <td>
                              <tr>
                                <td>Fellow</td>
                              </tr>
                              <br />
                              <tr>
                                <td>Life member</td>
                              </tr>
                              <br />
                              <tr>
                                <td>Member</td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions?.fellow
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "fellow"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions
                                        ?.life_member
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "life_member"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyDown={(e) => Restrict(e)}
                                    placeholder="Enter Count"
                                    className="fieldinput"
                                    value={
                                      apply?.professional_contributions?.member
                                    }
                                    onChange={(e) =>
                                      setData(
                                        e.target.value,
                                        "professional_contributions",
                                        "member"
                                      )
                                    }
                                    onWheelCapture={e => { e.target.blur() }}
                                  />
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions?.fellow
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions
                                      ?.life_member?.per_actitity_score
                                  }
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {
                                    count?.professional_contributions?.member
                                      ?.per_actitity_score
                                  }
                                </td>
                              </tr>
                            </td>
                            <td>
                              <tr>
                                <td>
                                  {apply?.professional_contributions?.fellow *
                                    count?.professional_contributions?.fellow
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.professional_contributions
                                    ?.life_member *
                                    count?.professional_contributions
                                      ?.life_member?.per_actitity_score}
                                </td>
                              </tr>
                              <br />
                              <tr>
                                <td>
                                  {apply?.professional_contributions?.member *
                                    count?.professional_contributions?.member
                                      ?.per_actitity_score}
                                </td>
                              </tr>
                            </td>
                          </tr>
                          <tr>
                            <td className="tablewidth">Total</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              {apply?.professional_contributions
                                ?.resource_person_in_training_programmes *
                                count?.professional_contributions
                                  ?.resource_person_in_training_programmes
                                  ?.per_actitity_score +
                                apply?.professional_contributions
                                  ?.training_programmes_attended_international *
                                count?.professional_contributions
                                  ?.training_programmes_attended_international
                                  ?.per_actitity_score +
                                apply?.professional_contributions
                                  ?.training_programmes_attended_national *
                                count?.professional_contributions
                                  ?.training_programmes_attended_national
                                  ?.per_actitity_score +
                                apply?.professional_contributions
                                  ?.participation_and_academic_contributions_international *
                                count?.professional_contributions
                                  ?.participation_and_academic_contributions_international
                                  ?.per_actitity_score +
                                apply?.professional_contributions
                                  ?.participation_and_academic_contributions_national *
                                count?.professional_contributions
                                  ?.participation_and_academic_contributions_national
                                  ?.per_actitity_score +
                                apply?.professional_contributions
                                  ?.participation_and_academic_contributions_state *
                                count?.professional_contributions
                                  ?.participation_and_academic_contributions_state
                                  ?.per_actitity_score +
                                apply?.professional_contributions
                                  ?.overseas_visited_for_academic_events *
                                count?.professional_contributions
                                  ?.overseas_visited_for_academic_events
                                  ?.per_actitity_score +
                                apply?.professional_contributions
                                  ?.overseas_visited_for_part_of_delegation *
                                count?.professional_contributions
                                  ?.overseas_visited_for_part_of_delegation
                                  ?.per_actitity_score +
                                apply?.professional_contributions
                                  ?.participation_and_contributions_in_pg_examiner *
                                count?.professional_contributions
                                  ?.participation_and_contributions_in_pg_examiner
                                  ?.per_actitity_score +
                                apply?.professional_contributions
                                  ?.participation_and_contributions_in_doctoral_committee *
                                count?.professional_contributions
                                  ?.participation_and_contributions_in_doctoral_committee
                                  ?.per_actitity_score +
                                apply?.professional_contributions
                                  ?.participation_and_contributions_in_phd_examiner *
                                count?.professional_contributions
                                  ?.participation_and_contributions_in_phd_examiner
                                  ?.per_actitity_score +
                                apply?.professional_contributions
                                  ?.editor_in_cheif_sci *
                                count?.professional_contributions
                                  ?.editor_in_cheif_sci?.per_actitity_score +
                                apply?.professional_contributions
                                  ?.editor_in_cheif_scopus *
                                count?.professional_contributions
                                  ?.editor_in_cheif_scopus
                                  ?.per_actitity_score +
                                apply?.professional_contributions
                                  ?.editorial_board_member_sci *
                                count?.professional_contributions
                                  ?.editorial_board_member_sci
                                  ?.per_actitity_score +
                                apply?.professional_contributions
                                  ?.editorial_board_member_scopus *
                                count?.professional_contributions
                                  ?.editorial_board_member_scopus
                                  ?.per_actitity_score +
                                apply?.professional_contributions
                                  ?.peer_reviewer_sci *
                                count?.professional_contributions
                                  ?.peer_reviewer_sci?.per_actitity_score +
                                apply?.professional_contributions
                                  ?.peer_reviewer_scopus *
                                count?.professional_contributions
                                  ?.peer_reviewer_scopus?.per_actitity_score +
                                apply?.professional_contributions
                                  ?.international_academic_assignment *
                                count?.professional_contributions
                                  ?.international_academic_assignment
                                  ?.per_actitity_score +
                                apply?.professional_contributions
                                  ?.national_academic_assignment *
                                count?.professional_contributions
                                  ?.national_academic_assignment
                                  ?.per_actitity_score +
                                apply?.professional_contributions?.fellow *
                                count?.professional_contributions?.fellow
                                  ?.per_actitity_score +
                                apply?.professional_contributions?.life_member *
                                count?.professional_contributions?.life_member
                                  ?.per_actitity_score +
                                apply?.professional_contributions?.member *
                                count?.professional_contributions?.member
                                  ?.per_actitity_score}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      {/* <div className="my-5 checkbox-apar">
                        <input
                          type="checkbox"
                          checked={apply?.ckeck}
                          onChange={(e) =>
                            setNormalData(e.target.checked, "check")
                          }
                        />
                        <label className="ms-3">
                          Test acknowledgement checkbox
                        </label>
                      </div> */}
                      <div className="row my-5">
                        <div className="col-lg-2 mx-auto my-auto centertext">
                          <div
                            className="approvebutton"
                            onClick={(e) => {
                              e.preventDefault();

                              setStatusAcceptModel(true);
                            }}
                          >
                            Submit
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {/*  ApproveModal */}
                  <CustomModal
                    open={statusAcceptModel}
                    onClickOutside={() => {
                      setStatusAcceptModel(false);
                    }}
                  >
                    <div className="modal-content Modal-View m-auto">
                      <div className="modalHeader text-center py-2">
                        <h5 className="font-bold mt-2">Confirmation !</h5>
                      </div>
                      <div className="modal-body p-0">
                        <div className="container">
                          <div></div>
                          <div>
                            <h6 className="confirmmodeltext my-4">
                              Are You Sure?
                            </h6>
                          </div>
                          <div>
                            <h6 className="confirmmodeltext my-4">
                              Once Submitted cannot be revote this !
                            </h6>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer border-0">
                        <div className="my-3">
                          <button
                            type="button"
                            className="btn mx-2 modelclosebtn"
                            onClick={() => {
                              setStatusAcceptModel(false);
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                        <div>
                          <button
                            className="btn mx-2 approvebutton"
                            onClick={(e) => handleSubmit(e)}
                          >
                            yes, Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </CustomModal>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default StaffPerformanceSpecific;
